export enum UserRole {
  ADMIN = 'ADMIN',
  HUB_MANAGER = 'HUB_MANAGER',
  OPERATOR = 'OPERATOR',
  CUSTOMER = 'CUSTOMER',
  COMPANY = 'COMPANY',
  AGENCY = 'AGENCY',
  FRANCHISE_AGENT = 'FRANCHISE_AGENT',
  HUB_AGENT = 'HUB_AGENT',
}
